import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { MDBBtn } from "mdb-react-ui-kit";
import { useLocation } from "react-router-dom";
import { useParams, useHistory } from "react-router-dom";
// config
import configData from "../../config/config.json";
// style
import "./registery.css";
// components
import MetaTagsBusinessOwners from "../../components/meta-tags-seo/MetaTagsBusinessOwners";
// img
import welImg from "../../images/registery/open mail.svg";

const WelcomePage = () => {
  const { param } = useParams();

  const history = useHistory();

  const location = useLocation();
  const [render, setRender] = useState(false);
  const queryParams = new URLSearchParams(location.search);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "welcome",
  };

  useEffect(() => {
    if (queryParams.get("email") && queryParams.get("id")) {
      const user_email = queryParams.get("email");
      const user_o = queryParams.get("id");
      const user_o2 = user_o.split(" ").join("+");

      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      var dataPost = {
        ownerId: user_o2,
        email: user_email,
      };
      axios
        .post(
          configData.API_DOMAIN + "/api/v1/BusinessOwners/approve",
          dataPost,
          {
            headers: headerMeta,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setRender(true);
            document.cookie =
              "OwnerIdConfirm=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
              "OwnerIdConfirm" +
              "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=en-biz.gishniz.com; path=/";
          } else {
            history.push("/404");
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      history.push("/login");
    }
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {render ? (
        <div className="registery-bg">
          <object
            data={welImg}
            alt={"welcome image"}
            className="registery-welcome-img"
          ></object>
          {/* <img
        src={welImg}
        alt="welcome image"
        className="registery-welcome-img"
      /> */}
          <div className="w-100">
            <div className="registery-cir-bg">
              <p className="registery-welcome-text">به گیشنیز خوش آمدی!</p>
            </div>
            <div className="registery-rec-bg">
              <div className="text-center d-md-flex justify-content-center pt-md-0 pt-5">
                <MDBBtn className="registery-welcome-btn1" href="/login">
                  ادامه ثبت کسب‌وکار
                </MDBBtn>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default WelcomePage;
